<template>
<el-container>
  <el-drawer :visible.sync="hotelSearchFrame" :title="$t('searchCriteria')" size="100%" class="search-dialog" :with-header="false">
    <!-- <div class="search-header">
      <div class="search-center">
        <div class="search-back" @click="dialog_close('hotelSearchFrame')"> <i class="el-icon-arrow-left"></i> </div>
        <div class="search-title">{{$t('searchCriteria')}}</div>
        <div class="search-close"></div>
      </div>
    </div> -->
    <div style="text-align:left">
      <div style="height:60px; background-color:rgba(79, 76, 76, 1);position: relative;">
        <div @click="dialog_close('hotelSearchFrame')">
          <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
        </div>
        <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('searchCriteria')}}</div>
      </div>
    </div>
      <!--搜索 开始-->
    <div class="list-search-info">
        <!--位置搜索 开始-->
        <div class="location-search-info">
          <div class="hotellist-region-info">
            <input type="text" autocomplete="off" :placeholder="$t('goingTo')" :value="region_mobile" class="el-input__inner" @click="addrSearch = true" readonly>
          </div>
          <div class="select-date-info"  @click="dateSearch = true">
            <div class="hotellist-date-mobile el-select--large">
              <div class="date-inner">
                  <div class="date-inner-start">
                    <div class="date-inner-check-img"></div>
                    <div class="date-inner-check-info">
                      <div class="date-inner-check-str home-search-text-12 font-999">{{$t('checkIn')}}</div>
                      <div class="date-inner-check-date home-search-text"><span v-if="language === 'zh'">{{checkDateWeek.date[0]}} {{checkDateWeek.week[0]}}</span><span v-else>{{checkDateWeek.week[0]}}, {{checkDateWeek.date[0]}}</span></div>
                    </div>
                  </div>
                  <div class="date-inner-division"></div>
                  <div class="date-inner-end">
                    <div class="date-inner-check-img"></div>
                    <div class="date-inner-check-info">
                      <div class="date-inner-check-str home-search-text-12 font-999">{{$t('checkOut')}}</div>
                      <div class="date-inner-check-date home-search-text"><span v-if="language === 'zh'">{{checkDateWeek.date[1]}} {{checkDateWeek.week[1]}}</span><span v-else>{{checkDateWeek.week[1]}}, {{checkDateWeek.date[1]}}</span></div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 入住人 -->
        <div class="search-person">
          <div class="search-line-15"></div>
          <div class="search-line home-search-text-16">
              <div class="search-center">
                  <div class="room-num">{{roomNum}}</div>
                  <div class="room-title">
                    <span v-if="roomNum<=1">{{$t('room')}}</span>
                    <span v-else>{{$t('rooms')}}</span>
                  </div>
                  <div class="room-button">
                    <button class="lass-button" :class="{'search-button-lass-gray': roomLessNoDo, 'search-button-lass-blue': roomLessDo}" @click="roomChange(1, $event)"></button>
                    <button class="add-button" :class="{'search-button-add-blue': roomAddDo, 'search-button-add-gray': roomAddNoDo}" @click="roomChange(2, $event)"></button>
                  </div>
              </div>
              <div style="clear:both"></div>
          </div>
          <div class="search-line home-search-text-16">
              <div class="search-center">
                  <div class="room-num">{{adultNum}}</div>
                  <div class="room-title">
                    <span v-if="adultNum<=1">{{$t('adult')}}</span>
                    <span v-else>{{$t('adults')}}</span>
                  </div>
                  <div class="room-button">
                    <button class="lass-button" :class="{'search-button-lass-blue': adultLessDo, 'search-button-lass-gray': adultLessNoDo}" @click="adultChange(1, $event)"></button>
                    <button class="add-button" :class="{'search-button-add-blue': adultAddDo, 'search-button-add-gray': adultAddNoDo}" @click="adultChange(2, $event)"></button>
                  </div>
              </div>
              <div style="clear:both"></div>
          </div>
          <div class="search-line home-search-text-16">
              <div class="search-center">
                  <div class="room-num">{{childNum}}</div>
                  <div class="room-title">
                    <span v-if="childNum<=1">{{$t('child')}}</span>
                    <span v-else>{{$t('children')}}</span>
                  </div>
                  <div class="room-button">
                    <button class="lass-button" :class="{'search-button-lass-blue': childLessDo, 'search-button-lass-gray': childLessNoDo}" @click="childChange(1, $event)"></button>
                    <button class="add-button" :class="{'search-button-add-blue': childAddDo, 'search-button-add-gray': childAddNoDo}" @click="childChange(2, $event)"></button>
                  </div>
              </div>
              <div style="clear:both"></div>
          </div>
          <div v-show="showChildInfo">
            <div class="home-search-text-12" style="text-align: left; width:100%; line-height: normal;" v-if="childNum<=1">
              <div style="width:90%; margin: 10px auto;text-align:left" v-html="$t('childAge')"></div>
            </div>
            <div class="home-search-text-12" style="text-align: left; width:100%; line-height: normal;" v-else>
              <div style="width:90%; margin: 10px auto;text-align:left" v-html="$t('childrenAges')"></div>
            </div>
            <div v-for="(n, nums) in childNum" :key="nums">
              <div class="search-line">
                <div class="child-center home-search-text-14">
                    <div class="child-text"><span style="margin-left:0px">{{$t('childNum')}}</span> {{nums}}</div>
                    <div class="child-button">
                      <div v-if="selecteds[nums] == undefined"><el-select class="selectOld" value="<1" placeholder="-" @change="updateChildSelect(nums, $event)" :popper-append-to-body="false"><el-option v-for="(value, key) in childOld" :key="key" :label="value" :value="value" style="text-align:center"></el-option></el-select></div>
                      <div v-else><el-select class="selectOld" v-model="selecteds[nums]" placeholder="-" :popper-append-to-body="false"><el-option v-for="(value, key) in childOld" :key="key" :label="value" :value="value" style="text-align:center"></el-option></el-select></div>
                    </div>
                </div>
                <div style="clear:both"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="search-button">
          <el-button @click="submitSearchCond">{{$t('search')}}</el-button>
        </div>
        <!--位置搜索 结束-->
    </div>
    <!--搜索 结束-->
    <div style="clear:both;height: 120px;"></div>
  </el-drawer>
  <publicSearch :addrSearch="addrSearch" :regionSearch="region_mobile" @getSonRegion="getSonRegion" @closepop="closepopEven"></publicSearch>
  <publicSearch :dateSearch="dateSearch" :checkDateSearch="checkDate" :addrDateTime="addrDateTimeS" @getSonDate="getSonDate" @closepop="closepopEven"></publicSearch>
</el-container>
</template>

<script>
import publicSearch from '@/components/public/publicSearch'
const childSelected = {'0': 'selectedone'}
export default {
  name: 'HotelSearch',
  props: ['hotelSearchFrame', 'typeSearch', 'typeIdSearch', 'regionSearch', 'checkDateSearch', 'selectedsSearch', 'roomNumSearch', 'adultNumSearch', 'childNumSearch', 'addrDateTime'],
  components: {
    publicSearch
  },
  data () {
    return {
      input_region: '',
      input_date: '',
      checkDate: [],
      checkDateWeek: {'date': ['', ''], 'week': ['', '']},
      input_person: '',
      addrSearch: false,
      dateSearch: false,
      activeIndex: 0,
      condNum: 0,
      inputVisible: false,
      inputValue: '',
      selectConds: [],
      selectLevelConds: [],
      selectBudgetConds: [],
      selecteds: [],
      roomNum: 1,
      adultNum: 2,
      childNum: 0,
      adultInfo: 2,
      childInfo: 0,
      personInfo: '2',
      roomInfo: '1',
      num: 1,
      roomLessDo: false,
      roomLessNoDo: true,
      roomAddDo: true,
      roomAddNoDo: false,
      adultLessDo: true,
      adultLessNoDo: true,
      adultAddNoDo: false,
      adultAddDo: true,
      childLessDo: false,
      childLessNoDo: true,
      childAddDo: true,
      childAddNoDo: false,
      showChildInfo: false,
      childOld: this.common.childOld,
      childSelected: childSelected,
      selected: '',
      allPersonNum: 2,
      start_date: '开始日期',
      end_date: '结束日期',
      region_mobile: '',
      regions: {
        '7980': { 'id': '7980', 'type': '1', 'value': '纽约，美国', 'address': '纽约，美国', 'country': '美国', 'city': '纽约' },
        '767978': { 'id': '767978', 'type': '3', 'value': '大西洋城赌场度假酒店', 'address': '大西洋县，美国', 'country': '美国', 'city': '大西洋县' },
        '743455': { 'id': '743455', 'type': '3', 'value': '金块酒店', 'address': '大西洋县，美国', 'country': '美国', 'city': '大西洋县' },
        '438276': {'id': '438276', 'type': '3', 'value': '纽约曼哈顿时代广场酒店(The Manhattan at Times Square Hotel New York)', 'address': '纽约，美国', 'country': '美国', 'city': '纽约'}
      },
      region_select: '',
      region_type: '',
      language: this.common.languageSet(this),
      addrDateTimeS: this.addrDateTime
    }
  },
  watch: {
    checkDate: function (n, o) {
      if (n[0] === undefined) {
        return false
      }
      this.checkDateWeek = {}
      this.checkDate = n
      this.dateUpdate(n)
    },
    typeSearch: function (news) {
      this.region_type = news
    },
    typeIdSearch: function (news) {
      this.region_select = news
    },
    regionSearch: function (news) {
      this.region_mobile = news
    },
    checkDateSearch: function (news) {
      console.log(news)
      this.checkDate = news
    },
    roomNumSearch: function (news) {
      this.roomNum = news
      if (news > 1) {
        this.roomLessDo = true
      }
    },
    adultNumSearch: function (news) {
      this.adultNum = news
      if (news > 1) {
        this.adultLessDo = true
      }
      if (news <= 1) {
        this.adultLessDo = false
      }
    },
    childNumSearch: function (news) {
      this.childNum = news
      if (news > 1) {
        this.childLessDo = true
      }
      if (news >= 1) {
        this.showChildInfo = true
        this.selecteds = this.selectedsSearch
      }
    },
    addrDateTimeS: function (newTime, oldTime) {
      const newdate = new Date(newTime)
      newdate.setDate(newdate.getDate() + 1)
      const newDateStr = newdate.toISOString().split('T')[0]

      this.checkDate = []
      this.checkDate.push(newTime)
      this.checkDate.push(newDateStr)
    }
  },
  methods: {
    dateUpdate: function (newDate) {
      let startDate = new Date(newDate[0].replace(/-/g, '/'))
      let startY = startDate.getFullYear()
      let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)
      let startMen = startDate.getMonth()
      let startD = startDate.getDate()
      let startW = startDate.getDay()

      let endDate = new Date(newDate[1].replace(/-/g, '/'))
      let endY = endDate.getFullYear()
      let endM = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
      let endMen = endDate.getMonth()
      let endD = endDate.getDate()
      let endW = endDate.getDay()

      var startYmd = ''
      var endYmd = ''
      var startwkstr = ''
      var endwkstr = ''
      if (this.language === 'en') {
        // Sep 15, 2022
        if (this.common.isMobile() === false) {
          startYmd = this.common.monthEn[startMen] + ' ' + startD + ', ' + startY
          endYmd = this.common.monthEn[endMen] + ' ' + endD + ', ' + endY
        } else {
          startYmd = this.common.monthEn[startMen] + ' ' + startD
          endYmd = this.common.monthEn[endMen] + ' ' + endD
        }
        startwkstr = this.common.weekEn[startW]
        endwkstr = this.common.weekEn[endW]
      } else {
        if (this.common.isMobile() === false) {
          startYmd = startY + '年' + startM + '月' + startD + '日'
          endYmd = endY + '年' + endM + '月' + endD + '日'
          startwkstr = this.common.weekZh[startW]
          endwkstr = this.common.weekZh[endW]
        } else {
          startYmd = startM + '月' + startD + '日'
          endYmd = endM + '月' + endD + '日'
          startwkstr = this.common.weekMobileZh[startW]
          endwkstr = this.common.weekMobileZh[endW]
        }
      }

      this.checkDateWeek.date = []
      this.checkDateWeek.date.push(startYmd)
      this.checkDateWeek.date.push(endYmd)

      this.checkDateWeek.week = []
      this.checkDateWeek.week.push(startwkstr)
      this.checkDateWeek.week.push(endwkstr)
    },
    // 房间减少
    roomChange: function (type, e) {
      if (type === 1) {
        if (this.roomNum > 1) {
          this.roomNum--
          if (this.roomNum === 1) {
            this.roomLessDo = false
            this.roomLessNoDo = true
            return false
          }
          if (this.roomNum < 8) {
            this.roomAddNoDo = false
            this.roomAddDo = true
          }
        }
      } else {
        if (this.roomNum < 8) {
          this.roomNum++
          this.roomLessDo = true
          this.roomLessNoDo = false
          this.roomAddDo = true
          this.roomAddNoDo = false
          if (this.roomNum === 8) {
            this.roomLessDo = true
            this.roomLessNoDo = false
            this.roomAddDo = false
            this.roomAddNoDo = true
          }
          if (this.roomNum > this.adultNum) {
            this.adultNum = this.roomNum
            this.adultLessDo = true
            this.adultLessNoDo = false
          }
        }
      }
    },
    adultChange: function (type, e) {
      if (type === 1) {
        if (this.adultNum > 1) {
          this.adultNum--
          if (this.adultNum === 1) {
            this.adultLessDo = false
            this.adultLessNoDo = true
            return false
          }
          if (this.adultNum <= 10 && this.roomNum > this.adultNum) {
            this.roomNum = this.adultNum
            if (this.roomNum === 1) {
              this.roomLessDo = false
              this.roomLessNoDo = true
            }
            if (this.roomNum < 8) {
              this.roomAddNoDo = false
              this.roomAddDo = true
            }
          }
        }
      } else {
        this.adultNum++
        this.adultLessDo = true
        this.adultLessNoDo = false
      }
    },
    childChange: function (type, e) {
      if (type === 1) {
        if (this.childNum > 0) {
          this.childNum--
          if (this.childNum === 0) {
            this.childLessDo = false
            this.childLessNoDo = true
            this.childAddDo = true
            this.childAddNoDo = false
          }
        }
        if (this.childNum === 0) {
          this.showChildInfo = false
        }
        this.selecteds.pop()
      } else {
        if (this.childNum < 10) {
          this.childNum++
          this.childLessDo = true
          this.childLessNoDo = false
          if (this.childNum === 10) {
            this.childAddNoDo = true
            this.childAddDo = false
          }
        }
        if (this.childNum === 1) {
          this.showChildInfo = true
        }
        this.selecteds[this.childNum - 1] = '<1'
      }
    },
    dialog_close: function (type) {
      // 查看房型
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      })

      this.$emit('closepop', type)
    },
    closepopEven: function (type) {
      if (type === 'addrSearch') {
        this.addrSearch = false
      }
      if (type === 'dateSearch') {
        this.dateSearch = false
      }
    },
    getSonDate (val) {
      this.checkDate = val
      this.start_date = val[0]
      this.end_date = val[1]
    },
    getSonRegion (val) {
      this.region_mobile = val.region
      this.region_select = val.type_id
      this.region_type = val.type

      // 选择后，日期是否需要打开昨日房
      this.addrDateTimeS = val.zDateTime
    },
    submitSearchCond () {
      // 查看房型
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      })

      this.allPersonNum = this.adultNum + this.childNum

      var date1 = new Date(this.start_date.replace(/-/g, '/'))
      var date2 = new Date(this.end_date.replace(/-/g, '/'))
      var year1 = parseInt(date1.getFullYear())
      var year2 = parseInt(date2.getFullYear())
      var month1 = parseInt(date1.getMonth())
      var month2 = parseInt(date2.getMonth())
      var tian1 = parseInt(date1.getDate())
      var tian2 = parseInt(date2.getDate())
      month1 = parseInt(month1 + 1)
      month2 = parseInt(month2 + 1)

      var monthSelect1 = month1 < 10 ? '0' + month1.toString() : month1.toString()
      var monthSelect2 = month2 < 10 ? '0' + month2.toString() : month2.toString()
      var tianSelect1 = parseInt(tian1) < 10 ? '0' + parseInt(tian1).toString() : parseInt(tian1).toString()
      var tianSelect2 = parseInt(tian2) < 10 ? '0' + parseInt(tian2).toString() : parseInt(tian2).toString()

      this.start_date = year1.toString() + '-' + monthSelect1.toString() + '-' + tianSelect1.toString()
      this.end_date = year2.toString() + '-' + monthSelect2.toString() + '-' + tianSelect2.toString()

      var submitInfo = {'region': this.region_mobile, 'type_id': this.region_select, 'type': this.region_type, 'start_date': this.start_date, 'end_date': this.end_date, 'room': this.roomNum, 'adult': this.adultNum, 'child': this.childNum, 'allPersonNum': this.allPersonNum, 'childNums': this.selecteds}
      // console.log(submitInfo)

      // 点击 列表/详情页 搜索埋点记录
      var searchButtonData = {
        'checkin_date': submitInfo['start_date'],
        'checkout_date': submitInfo['end_date'],
        'rooms': submitInfo['room'],
        'adults': submitInfo['adult'],
        'childs': submitInfo['child'],
        'babys': submitInfo['childNums'],
        'region': submitInfo['region']
      }
      console.log('searchButtonData', searchButtonData)
      this.clickPageAction('search_button', '', searchButtonData)

      this.$emit('getSearchCond', submitInfo)

      this.$options.methods.dialog_close.bind(this)('hotelSearchFrame')
    },
    modeUpdate: function () {
      this.$forceUpdate()
    },
    updateChildSelect: function (num, e) {
      this.selecteds[num] = e
      this.$forceUpdate()
    }
  },
  mounted () {
    // 日期更新
    this.checkDate = this.checkDateSearch
    this.dateUpdate(this.checkDateSearch)
    // 成人关闭
    if (this.adultNumSearch <= 1) {
      this.adultLessDo = false
    }
    var params = this.$route.query
    var searchData = '{}'
    if (this.$route.path.indexOf('HotelDetail') === -1) {
      searchData = localStorage.getItem('searchData')
    }
    if (JSON.stringify(params) === '{}' && (searchData !== '{}' && searchData !== null && searchData !== 'null')) {
      params = JSON.parse(searchData)
      console.log(params)
      this.region_mobile = params.region
      this.region_select = params.type_id
      this.region_type = params.type
      this.roomNum = params.room
      this.adultNum = params.adult
      this.childNum = params.child
      this.childInfo = params.child
      if (this.childNum !== undefined && this.childNum !== null && this.childNum !== '' && this.childNum > 0 && !isNaN(this.childNum)) {
        this.showChildPublicInfo = true
        this.selecteds = []
        this.selecteds = params.childNums
      }
      this.start_date = params.start_date
      this.end_date = params.end_date
    } else {
      var regionselect = this.$route.query.region
      this.region_select = regionselect
      if (regionselect !== undefined && regionselect !== null && regionselect !== '') {
        this.region_mobile = regionselect
      }
      var date1 = new Date(this.checkDate[0].replace(/-/g, '/'))
      var date2 = new Date(this.checkDate[1].replace(/-/g, '/'))
      var year1 = date1.getFullYear()
      var year2 = date2.getFullYear()
      this.start_date = year1 + '-' + (date1.getMonth() + 1) + '-' + date1.getDate()
      this.end_date = year2 + '-' + (date2.getMonth() + 1) + '-' + date2.getDate()
      var adult = parseInt(this.$route.query.adult)
      var child = parseInt(this.$route.query.child)
      var room = parseInt(this.$route.query.room)
      if (adult !== undefined && adult !== null && adult !== '' && !isNaN(adult)) {
        this.adultNum = adult
        this.adultInfo = adult
      }
      if (room !== undefined && room !== null && room !== '' && !isNaN(room)) {
        this.roomNum = room
        this.roomInfo = room
      }
      if (child !== undefined && child !== null && child !== '' && child > 0 && !isNaN(child)) {
        var childNums = params.childNums
        this.childNum = child
        this.childInfo = child
        this.showChildPublicInfo = true
        this.selecteds = []
        this.selecteds = childNums
      }
      // 酒店详情页 修改选中元素
      if (this.$route.path.indexOf('HotelDetail') !== -1) {
        this.region_select = this.$route.query.hotelid
        this.region_type = 3
      }
    }
    // var state = localStorage.getItem('state')
    // if (state !== null && state !== '') {
    //   this.region_mobile = state
    // }
    // var regionselect = this.$route.query.region
    // this.region_select = regionselect
    // if (regionselect !== undefined && regionselect !== null && regionselect !== '') {
    //   this.region_mobile = regionselect
    // }
  }
}
</script>

<style scoped>
.el-drawer__body{ overflow: auto; }
.el-drawer__container ::-webkit-scrollbar{ display: none; }
.el-main{text-align: left;}
.main{background-color: #fff;width:100%;}
.el-drawer__wrapper{overflow: visible!important;}
.search-dialog{width:100%;overflow: visible!important;}
.search-dialog .search-header{width:100%;min-height:50px;background:rgba(79, 76, 76, 1);line-height:50px;text-align:center;font-size:16px;color:white;}
.search-dialog .search-center{width:90%;height:100%;margin:0 auto;}
.search-dialog .search-header .search-center .search-back{width:15%;height:100%;float:left;font-size:25px;text-align:left;}
.search-dialog .search-header .search-center .search-close{width:15%;height:100%;float:left;}
.search-dialog .search-header .search-center .search-title{width:70%;height:100%;float:left;}
/* 搜索条件 开始 */
.list-search-info{width: 100%;height: auto;-ms-overflow-x: hidden;overflow-x: hidden;-ms-overflow-y: hidden;overflow-y: hidden;margin: 0 auto;line-height: 48px;}
.location-search-info{width:90%;line-height:64px;margin: 0 auto;}
/* 目的地 */
.location-search-info .hotellist-region-info{width:100%;}
.hotellist-region-info input{background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-region.png);background-repeat:no-repeat;background-size: 23px;background-position: 10px center;padding: 0px 40px;width: 100%; height: 48px;font-size: 14px;opacity:1;}
.hotellist-region-info input:focus,.hotellist-date.el-range-editor.is-active, .hotellist-date.el-range-editor.is-active:focus{border-color:#DCDFE6;}

/* 入住人 */
.person-inner-info{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;line-height: 20px;outline: 0;margin: 0em;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-person.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;opacity:1; cursor: pointer;}
.inphotellistut-person .person-inner-info:hover{border-color:rgb(252, 210, 5, 1);}
.el-select-dropdown{display:none;}
.personLessno{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png"); border: none; background-color: #fff;}
.personLessno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png")}
.personLess{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
.personLess:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-less-20x20.png");}
.personnum{position: relative;display: inline-block;width: 100%;line-height: 38px;text-align: center;}
.personAdd{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-20x20.png");border: none; background-color: #fff;}
.personAdd:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-20x20.png");}
.personAddno{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png");}
.personAddno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png")}
.personnum span{display:inline-block;}
.personnum input{border:none;outline:none;width:20px;height:32px;color:#409EFF;font-weight: 400; font-size: 18px;}
.personnum input:focus{border:0;outline:none;width:20px;height:32px;}
.spantext{color:#999999; font-size: 14px;}
.select-person-info{width:100%;vertical-align: -webkit-baseline-middle;margin-top: 13px;}
.showPersonBorder{border-color:rgb(252, 210, 5, 1);box-shadow: 0 2px 4px 0 #ecd269, 0 0 6px 0 #ecd269;}
.showPersonBorder:hover{border-color:rgb(252, 210, 5, 1);}
.personText{font-weight: 650; font-size:14px;color: #4F4C4C;display:block;white-space: nowrap;overflow: hidden;}
.roomText{font-size:14px;color: #999999;white-space: nowrap;overflow: hidden;}
.childPublicInfo .el-select-dropdown,.el-select-dropdown{display:block}
.selectPublicOld{width: 40%;float: left;margin-left: 5%;}
/* 加减成人 */
.personLessno{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png");}
.personLess{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
/* 入住人选择 */
.personPublicInfo{border-width: 0px;width: 100%;height: auto;background: inherit;background-color: rgba(255, 255, 255, 1);border-radius: 4px;border: 1px solid #DCDFE6; color: #999999;font-size: 14px;}
/* 搜索 */
.hotellist_button{width:90%;height:48px;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
.hotellist_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(252, 210, 5, 1);}
.hotellist_button:focus{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
/* 搜索条件 结束 */

/* 日期 */
.hotellist-date-mobile{width: 100%; height: 48px;font-size: 16px;opacity:1;}
.date-inner{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;margin: 0em;background-color:rgba(255,255,255,1);width: 100%; height: 48px;opacity:1; cursor: pointer;font-size: 14px;}
.date-inner .date-inner-start{width: 49%;height: 100%;float:left;overflow:hidden;}
.date-inner .date-inner-division{border-right: solid 1px #797979;width: 1%;height: 100%;line-height: 45px;float:left;overflow:hidden}
.date-inner .date-inner-end{width: 49%;height: 100%;line-height: 45px;float:left;overflow:hidden;}
.date-inner .date-inner-check-img{width: 40px;height: 100%;background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 20px;background-position: 10px center;float:left;}
.date-inner .date-inner-check-info{width: 60%;height: 100%;float:left;}
.date-inner .date-inner-check-str{width: 100%;height: 50%;line-height: 30px;}
.date-inner .date-inner-check-date{width: 100%;height: 50%;line-height: 17px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}

/* 入住人搜索 */
.search-person{width:100%;}
.search-person .search-line-15{width:100%;min-height:15px;border-bottom:solid 1px #DCDFE2;}
.search-person .search-line{width:100%;min-height:60px;background:white;line-height:60px;text-align:left;font-size:16px;border-bottom:solid 1px #DCDFE2;font-weight:600;}
.search-person .search-line span{margin-left:2%;}
.search-person .search-line .search-center .room-num{width:20%;height:100%;float:left;text-align:left;}
.search-person .search-line .search-center .room-title{width:40%;height:100%;float:left;}
.search-person .search-line .search-center .room-button{width:40%;height:100%;float:left;text-align:right;font-size: 25px;}
.search-button-gray{color:gray;}
.search-button-blue{color:#2794F9;}
.child-text{ width:35%; height:100%;float:left;font-weight:400;}
.child-button{ width:100px;height:100%;float:right;text-align:right;font-size: 25px;}
.child-center{width:90%;height:100%;margin:0 auto;}
/deep/ .el-select-dropdown__item{text-align:left;font-weight: 400;}

/* 确认 */
.search-dialog .search-button{position: fixed;bottom: 0px;text-align: center;background: white;height: 60px;width: 100%;line-height:60px;}
.search-dialog .search-button button{width: 90%;height: 80%;font-size: 14px;background: rgba(79, 76, 76, 1);color: white;font-weight: 500;border:none;box-shadow: 2px 2px 12px #dcdfe2;border-radius: 4px;}
.search-button{width:100%;text-align: center;margin-top: 25px;}

.home-search-text-12{font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-size:12px;}
.home-search-text-14{font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-size:14px;}
.home-search-text-16{font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-size:16px;}

.lass-button{width: 25px;height: 25px;vertical-align:middle;border: none; background-color: #fff;}
.add-button{width: 25px;height: 25px;vertical-align:middle;border: none; background-color: #fff;}
.search-button-lass-gray{background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
.search-button-lass-blue{background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-less-20x20.png");}
.search-button-add-gray{background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-20x20.png");}
.search-button-add-blue{background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-20x20.png");}
/deep/ .el-select-dropdown__wrap {max-height:200px!important;}
/deep/ .el-popper[x-placement^=bottom]{margin-top: 0px;}
/deep/ .el-popper[x-placement^=top]{margin-bottom: 0px;}
.el-select{-webkit-tap-highlight-color: transparent !important;}
</style>



// WEBPACK FOOTER //
// src/components/hotelsearch/HotelSearch.vue